(function () {
  'use strict';

  angular
    .module('app', ['ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'restangular',
      'ui.router',
      'ui.bootstrap',
      'slickCarousel',
      'toastr',
      'ngMap']);

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('appTitle', title);

  function title() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/title/title.html',
      scope: {
        titulo: '@'
      }
    };
    return directive;
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('appRoute', title);

  function title() {
    var directive = {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/router-link/router-link.html',
      scope: {
        route:'@',
        link:'@',
        identificador:'@',
        nome:'@',
        scrollTo:'@'
      },
      controller: routerLinkController,
      controllerAs: 'vm'
    };
    return directive;
  }
  routerLinkController.$inject = ['$scope', '$state'];

  function routerLinkController($scope, $state) {
    var vm = this;
    vm.route = $scope.route;
    vm.link = $scope.link;
    vm.identificador = $scope.identificador;
    vm.scrollTo = $scope.scrollTo;
    vm.nome = $scope.nome;


    vm.createLink = createLink;

    function createLink() {
      if (!vm.route) {
        return vm.link;
      }
      if (vm.identificador) {
        return $state.href(vm.route, {identificador: vm.identificador, scrollTo: vm.scrollTo});
      }
      if (vm.category) {
        return $state.href(vm.route, {identificador: vm.category.identificador, scrollTo: vm.scrollTo});
      }
      if(vm.scrollTo) {
        return $state.href(vm.route, {scrollTo: vm.scrollTo});
      }
      return $state.href(vm.route);
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      transclude: false,
      templateUrl: 'app/components/navbar/navbar.html',
      controller: NavbarController,
      controllerAs: 'navController'
    };

    return directive;

    /** @ngInject */
    function NavbarController($state, cliente) {
      var vm = this;
      vm.navs = [];
      vm.link = link;
      vm.cliente = cliente;
      init();

      function init() {
        vm.navs.push({id: 1, scrollTo:'header', name: 'Home', route: 'home'});
        vm.navs.push({id: 1, scrollTo:'footer', name: 'Contato', route: 'contato'});
      }

      function link(nav) {
        if (!nav.route) {
          return nav.link;
        }
        if (nav.identificador) {
          return $state.href(nav.route, {identificador: nav.identificador, scrollTo: nav.scrollTo});
        }
        if (nav.category) {
          return $state.href(nav.route, {identificador: nav.category.identificador, scrollTo: nav.scrollTo});
        }
        if(nav.scrollTo) {
          return $state.href(nav.route, {scrollTo: nav.scrollTo});
        }
        return $state.href(nav.route);
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('jcarouselItem', jcarouselItem);

  /** @ngInject */
  function jcarouselItem() {
    var directive = {
      require: '^jcarousel',
      transclude: true,
      replace: true,
      restrict: 'E',
      templateUrl: 'app/components/jcarousel/jcarousel-item.html',
      scope: {
        images: '=',
        thumbnails: '=',
        styleClass: '='
      },
      controller: jcarouselItemController,
      controllerAs: 'vm',
      link: {
        post:link
      }
    };
    return directive;
  }

  jcarouselItemController.$inject = ['$scope'];

  function jcarouselItemController($scope) {
    var vm = this;
    vm.images = $scope.images;
    vm.thumbnails = $scope.thumbnails;
    vm.styleClass = $scope.styleClass;
    vm.active;
    vm.setActive = setActive;

    function setActive(value) {
      vm.active = value;
    }
  }

  function link(scope, element, attrs, carouselCtrl) {
    carouselCtrl.addItem(scope, element, attrs);

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('jcarousel', jcarousel);

  /** @ngInject */
  function jcarousel() {
    var directive = {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/components/jcarousel/jcarousel.html',
      scope: {
        itens: '=',
        quantidade: '=?bind'
      },
      controller: jcarouselController,
      controllerAs: 'vm',
      link: link
    };
    return directive;
  }


  jcarouselController.$inject = ['$scope', '$element'];

  function jcarouselController($scope, $element) {
    var vm = this;
    $scope.quantidade = 0;
    vm.itens = $scope.itens || [];

    vm.addItem = addItem;
    vm.prev = prev;
    vm.next = next;

    function prev() {
      target(getElement(), "-=1");
    }

    function next() {
      target(getElement(), "+=1");
    }

    function addItem(item, element) {
      vm.itens.push({
        item: item,
        element: element
      });
      $scope.quantidade++;
    }

    function getElement() {
      return $element.find('.jcarousel');
    }

    function target(element, target) {
      element.jcarousel('scroll', target, true);
    }
  }


  function init(find) {
    find.on('jcarousel:reload jcarousel:create jcarousel:reloadend', function (el) {
        var ac = jQuery(el.target);
        var width = ac.innerWidth();

        if (width >= 1000) {
          width = width / 4;
        } else if (width >= 640) {
          width = width / 3;
        } else if (width >= 400) {
          width = width / 2;
        }

        ac.jcarousel('items').css('width', Math.ceil(width) + 'px');
      })
      .jcarousel({
        wrap: 'circular'
      });
  }

  function link(scope, element) {
    var jCarousel = element.find('.jcarousel');
    init(jCarousel);
    scope.$watch('quantidade', function (newValue, oldValue) {
      if (oldValue === newValue) {
        return;
      }
      jCarousel.jcarousel('reload');
    });


    angular.forEach(element.find('[data-jcarousel-control]'), function (item) {
      var el = jQuery(item);
      el.jcarouselControl(el.data());
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('gridGallery', gridGallery);

  /** @ngInject */
  function gridGallery() {
    var directive = {
      restrict: 'AE',
      templateUrl: 'app/components/gridGallery/gridGallery.html',
      scope: {
        image: '='
      },
      replaceAll: true,
      controller: gridGalleryController,
      controllerAs: 'vm'
    };

    return directive;
  }

  gridGalleryController.$inject = ['$scope'];

  function gridGalleryController($scope) {
    var vm = this;
    vm.image = $scope.image;
  }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .directive('footer', footer);

    /** @ngInject */
    function footer() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/footer/footer.html',
            controller: FooterController,
            controllerAs: 'footerController'
        };

        return directive;

        /** @ngInject */
        function FooterController(NgMap) {
            var vm = this;
            vm.whatsApp = '(48) 99636-4820';
            vm.fone = '(48) 99636-4820';
            vm.mail = 'atendimento@ateliezeffa.com.br';
            vm.facebookLink = 'https://www.facebook.com/ateliezeffa';
            vm.facebook = '/ateliezeffa';
            vm.instagram = '/ateliezeffa';
            vm.instagramLink = 'https://www.instagram.com/ateliezeffa/';
            vm.empresa = 'Atelie Zeffa';
            vm.empresaDescricao = 'Venha conhecer o nosso trabalho!';
            vm.endereco = 'R. Cassemiro Smielevisk, 67 - Centro, Morro da Fumaça - SC, 8883500-000';
            vm.locations = [-28.600276, -49.251242];

            NgMap.getMap().then(function (map) {
                vm.map = map;
            });

            vm.showInfoWindow = showInfoWindow;

            function showInfoWindow(div) {
                vm.map.showInfoWindow(div)
            }
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('focus', focus);

  /** @ngInject */
  function focus($timeout) {
    var directive = {
      restrict: 'A',
      link: link
    };

    return directive;

    function link(scope, element, attrs) {
      scope.$watch(attrs.focus, function (newValue) {
        if (newValue) {
          $timeout(function () {
            element[0].focus();
          });
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular.module('app')
    .directive('formularioContato', formularioContato);

  function formularioContato() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/contato/contato.html',
      controller: contatoController,
      controllerAs: 'vmContato'
    };
    return directive;
  }

  contatoController.$inject = ['contatoService'];

  function contatoController(contatoService) {
    var vmContato = this;

    vmContato.contato = {};
    vmContato.sucess = false;
    vmContato.error = false;
    vmContato.formularioHabilitado = formularioHabilitado;
    vmContato.send = send;
    vmContato.clear = clear;

    function send() {
      vmContato.contato.subject = 'contato';
      vmContato.contato.message = vmContato.contato.mensagem;
      contatoService.sendMail(vmContato.contato)
        .then(function () {
          vmContato.sucess = true;
          vmContato.contato = {};
        })
    }

    function clear() {
      vmContato.contato = {};
    }

    function formularioHabilitado() {
      return vmContato.sucess === false && vmContato.error === false
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .service('contatoService', contatoService);

  contatoService.$inject = ['Restangular'];

  function contatoService(restangular) {

    return {
      sendMail: sendMail
    };

    function sendMail(contato) {
      return restangular.all('mail')
        .all('mailsend.php')
        .post(contato);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('carouselGallery', carouselGallery);

  /** @ngInject */
  function carouselGallery() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/carouselGallery/carouselGallery.html',
      scope: {
        images: '=',
        thumbnails: '=',
        styleClass:'='
      },
      controller: carouselGalleryController,
      controllerAs: 'vm'
    };
    return directive;
  }

  carouselGalleryController.$inject = ['$scope'];

  function carouselGalleryController($scope) {
    var vm = this;
    vm.images = $scope.images;
    vm.thumbnails = $scope.thumbnails;
    vm.styleClass= $scope.styleClass;
    vm.active;
    vm.setActive =setActive;

    function setActive(value) {
      vm.active = value;
    }
  }

})();

(function () {
  'use strict';

  angular.module('app')
    .controller('SobreController', SobreController);

  function SobreController() {
    var vm = this;

    vm.title = 'Sobre';

    vm.photoList = [
      {src:'assets/images/magos/empresa1.jpg'},
      {src:'assets/images/magos/empresa2.jpg'},
      {src:'assets/images/magos/empresa3.jpg'},
      {src:'assets/images/magos/empresa4.jpg'},
      {src:'assets/images/magos/empresa5.jpg'},
      {src:'assets/images/magos/empresa6.jpg'}
    ]


  }

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('VisualizacaoModalController', VisualizacaoModalController);

    VisualizacaoModalController.$inject = ['$uibModalInstance', '$document', '$scope', 'images', 'index'];


    function VisualizacaoModalController($uibModalInstance, $document, $scope, images, index) {
        var vm = this;

        vm.focus = true;
        vm.images = images;
        vm.index = index;
        vm.cancelar = _cancelar;
        vm.next = next;
        vm.previous = previous;
        vm.keypress = keypress;
        init();

        $document.on('keydown', keypress);

        function init() {

            vm.image = vm.images[vm.index];
        }

        function keypress($event) {
            if ($event.keyCode === 39) {
                vm.next();
            }
            if ($event.keyCode === 37) {
                vm.previous();
            }
            $scope.$apply();
        }

        function next() {
            vm.index++;
            if (vm.index >= vm.images.length) {
                vm.index = 0;
            }
            init();
        }

        function previous() {
            vm.index--;
            if (vm.index < 0) {
                vm.index = vm.images.length - 1;
            }
            init();
        }

        function _cancelar() {
            $uibModalInstance.dismiss();
        }
    }

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('RoupaController', RoupaController);

    RoupaController.$inject = ['$uibModal'];

    function RoupaController($uibModal) {
        var vm = this;

        vm.produtos = [];
        vm.openImage = openImage;

        init();

        function init() {
            for (var i = 1; i <= 18; i++) {
                vm.produtos.push({
                    src: "/assets/images/roupa" + i + ".jpg",
                    content: "Conteudo 1",
                    nome: "Nome 1",
                    identificador: "Identificador 1"
                });
            }
        }

        function openImage(positon) {
            $uibModal.open({
                controller: 'VisualizacaoModalController',
                controllerAs: 'vm',
                templateUrl: 'app/roupas/visualizacao.modal.html',
                windowTemplateUrl: 'splash/index.html',
                size: 'lg',
                keyboard: true,
                backdrop: true,
                resolve: {
                    images: function () {
                        return vm.produtos
                    },
                    index: positon
                }
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('app')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['NgMap', 'cliente'];

    function HomeController(NgMap, cliente) {
        var vm = this;

        vm.fermentos = [];
        vm.lupulos = [];
        vm.maltes = [];
        vm.title = '';

        vm.photoList = [
            {src: 'assets/images/magos/empresa1.jpg'},
            {src: 'assets/images/magos/empresa2.jpg'},
            {src: 'assets/images/magos/empresa4.jpg'},
            {src: 'assets/images/magos/empresa5.jpg'},
            {src: 'assets/images/magos/empresa6.jpg'}
        ];

        vm.slickConfig = {
            dots: true,
            autoplay: true,
            initialSlide: 2,
            infinite: true,
            autoplaySpeed: 5000
        };

        vm.locations = [-28.6806316, -49.372157];
        vm.empresa = cliente.nome;
        vm.empresaDescricao = 'Venha conhecer o nosso trabalho!';
        vm.endereco = 'R. Cassemiro Smielevisk, 67 - Centro, Morro da Fumaça - SC, 8883500-000';

        NgMap.getMap().then(function (map) {
            vm.map = map;
        });

        vm.showInfoWindow = showInfoWindow;

        function showInfoWindow(div) {
            vm.map.showInfoWindow(div)
        }

        init();

        function init() {

        }


    }

})();

(function () {
  'use strict';

  angular
    .module('app')
    .directive('header', footer);

  /** @ngInject */
  function footer() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/header/header.html',
      controller: HeaderController,
      controllerAs: 'headerController'
    };

    return directive;

    /** @ngInject */
    function HeaderController(cliente) {
      var vm = this;

      vm.cliente = cliente;

    }
  }

})();

(function () {
  'use strict';

  angular.module('app')
    .controller('ContatoController', ContatoController);

  function ContatoController() {
    var vm = this;

    vm.title = 'Contato';


  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .run(template);


  template.$inject = ['$templateCache']
  /** @ngInject */
  function template($templateCache) {
    $templateCache.put('splash/index.html',
      '<section modal-render="{{$isRendered}}" class="splash" modal-in-class="splash-open" ng-style="{\'z-index\': 10000, display: \'block\'}" ng-click="close($event)">' +
      '  <div class="splash-inner" ng-transclude></div>' +
      '</section>'
    );
  }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig)
        .run(run);

    function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
        /** @ngInject */
        $stateProvider
            .state('home', {
                url: '/mais/:scrollTo',
                templateUrl: 'app/home/home.html',
                controller: 'HomeController',
                controllerAs: 'vm',
                onEnter: scrollTo
            })
            .state('roupas', {
                url: '/roupas',
                templateUrl: 'app/roupas/roupas.html',
                controller: 'RoupaController',
                controllerAs: 'vm',
                onEnter: scrollTo
            });

        $urlRouterProvider.otherwise('/mais/');
        $locationProvider.html5Mode(true);
    }

    function scrollTo($stateParams, $timeout, $location, anchorSmoothScroll) {
        $timeout(function () {
            // $location.hash($stateParams.scrollTo);
            /* var element = document.getElementById($stateParams.scrollTo);
              smoothScroll(element, {
              duration: 700,
              easing: 'easeOutQuint',
              offset: 120
              });*/
            if ($stateParams.scrollTo) {
                anchorSmoothScroll.scrollTo($stateParams.scrollTo);
            }else{
                anchorSmoothScroll.scrollTo('titulo');
            }
        }, 100)
    }

    run.$inject = ['$rootScope', '$location', '$window'];

    function run($rootScope, $location, $window) {
        // initialise google analytics
        $window.ga('create', 'UA-103258426-1', 'auto');

        var regiter = $rootScope.$on('$stateChangeSuccess', function () {
            var path = $location.path();
            $window.ga('send', 'pageview', path);
        });

        $rootScope.$on('$destroy', regiter);

    }


})();

/* global _:true*/
(function () {
  'use strict';

  angular
    .module('app')
    .constant('_', _)
    .constant('API_URL','http://ateliezeffa.com.br')
    .constant('cliente', {
      clientId: 'abc',
      site: 'http://ateliezeffa.com.br',
      email: 'atendimento@ateliezeffa.com.br',
      nome: 'Ateliê Zeffa'
    });

})();

(function () {
    'use strict';


    angular
        .module('app')
        .config(config)
        .config(httpProvider)
        .config(restangular)
        .service('anchorSmoothScroll', smoothScroll)
    ;

    /** @ngInject */
    function config($logProvider, toastrConfig) {
        // Enable log
        $logProvider.debugEnabled(true);

        // Set options third-party lib
        toastrConfig.allowHtml = true;
        toastrConfig.timeOut = 3000;
        toastrConfig.positionClass = 'toast-top-right';
        toastrConfig.preventDuplicates = true;
        toastrConfig.progressBar = true;
    }

    /** @ngInject */
    function restangular(RestangularProvider, API_URL) {
        RestangularProvider.setBaseUrl(API_URL)
    }

    /** @ngInject */
    function httpProvider($httpProvider) {
        $httpProvider.defaults.useXDomain = true;
        delete $httpProvider.defaults.headers.common["X-Requested-With"];
    }

    function smoothScroll() {

        this.scrollTo = function (eID) {

            // This scrolling function
            // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

            var startY = currentYPosition();
            var stopY = elmYPosition(eID);
            var distance = stopY > startY ? stopY - startY : startY - stopY;
            if (distance < 100) {
                scrollTo(0, stopY);
                return;
            }
            var speed = Math.round(distance / 100);
            if (speed >= 20) speed = 20;
            var step = Math.round(distance / 25);
            var leapY = stopY > startY ? startY + step : startY - step;
            var timer = 0;
            if (stopY > startY) {
                for (i = startY; i < stopY; i += step) {
                    setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                    leapY += step;
                    if (leapY > stopY) leapY = stopY;
                    timer++;
                }
                return;
            }
            for (var i = startY; i > stopY; i -= step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY -= step;
                if (leapY < stopY) leapY = stopY;
                timer++;
            }

            function currentYPosition() {
                // Firefox, Chrome, Opera, Safari
                if (self.pageYOffset) return self.pageYOffset;
                // Internet Explorer 6 - standards mode
                if (document.documentElement && document.documentElement.scrollTop)
                    return document.documentElement.scrollTop;
                // Internet Explorer 6, 7 and 8
                if (document.body.scrollTop) return document.body.scrollTop;
                return 0;
            }

            function elmYPosition(eID) {
                var elm = document.getElementById(eID);
                var y = elm.offsetTop;
                var node = elm;
                while (node.offsetParent && node.offsetParent != document.body) {
                    node = node.offsetParent;
                    y += node.offsetTop;
                }
                return y;
            }

        };

    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/contato/contato.html","<div id=\"contato\"><div class=\"row\"><div class=\"col-md-6\"><h4>Contato</h4><formulario-contato></formulario-contato></div><div class=\"col-md-6\"><h4>Magos da cerveja</h4><div><p></p></div></div></div></div>");
$templateCache.put("app/header/header.html","<div id=\"header\"></div>");
$templateCache.put("app/home/home.html","<section id=\"banners\"><h3><a href=\"http://loja.ateliezeffa.com.br\">Conheça nossa loja</a></h3><div class=\"\"><div class=\"\"><div class=\"cards-slider\"><slick class=\"slider\" ng-if=\"true\" dots=\"true\" autoplay=\"true\" infinite=\"true\" autoplay-speed=\"4000\" speed=\"1000\"><li><div class=\"slide-content\"><div class=\"card-item\"><div class=\"news-item\"><div class=\"news-item-visuals\"><a href=\"roupas\"><img class=\"teste d-none d-sm-block\" src=\"/assets/images/1.jpg\"> <img class=\"teste d-block d-sm-none\" src=\"/assets/images/mobile1.jpg\"></a></div><div class=\"new-item-infos\"><div class=\"news-item-subtitle\"><a class=\"news-item-link\" href=\"roupas\" tabindex=\"0\">Nossa loja</a></div><div class=\"news-item-subtitle\"><a href=\"roupas\">Faça sua encomenta e pague em até 6x sem juros</a></div></div></div></div></div></li><li><div class=\"slide-content\"><div class=\"card-item\"><div class=\"news-item\"><div class=\"news-item-visuals\"><a href=\"roupas\"><img class=\"teste d-none d-sm-block\" src=\"/assets/images/2.jpg\"> <img class=\"teste d-block d-sm-none\" src=\"/assets/images/mobile2.jpg\"></a></div><div class=\"new-item-infos\"><div class=\"news-item-subtitle\"><a class=\"news-item-link\" href=\"roupas\" tabindex=\"0\">Toalhinhas</a></div><div class=\"news-item-subtitle\"><a href=\"roupas\">Temos diversas toalhinhas com personagens infantis</a></div></div></div></div></div></li></slick></div></div></div></section><section id=\"confeccao\"><h3>Roupas</h3><div class=\"row non-dots\"><div class=\"col-12\"><p class=\"text-justify mx-\">Todos os nosso produtos são de fabricação própria, com mão de obra especializada e humanizada. Buscamos oferecer aos nosso clientes produtos de alta qualidade com os melhores preços. Aceitamos encomendas de roupas sob medida.</p></div></div><div class=\"row non-dots\"><div class=\"col-12\"><app-route route=\"roupas\" scroll-to=\"titulo\"><img class=\"teste d-none d-sm-block\" alt=\"\" src=\"/assets/images/1.jpg\"> <img class=\"teste d-block d-sm-none\" alt=\"\" src=\"/assets/images/mobile2.jpg\"></app-route></div></div></section><section id=\"personalizacao\"><h3>Personalização</h3><div class=\"row non-dots\"><div class=\"col-12\"><p class=\"text-justify mx-\">Trabalhamos com customização de roupas e abadás, criando peças únicas e exclusivas. Também trabalhamos com a confecção de fantasias.</p></div></div></section><section id=\"contato\"><h3>Entre em contato</h3><formulario-contato></formulario-contato></section>");
$templateCache.put("app/roupas/roupas.html","<section id=\"maisRoupas\"><h3>Roupas</h3><div class=\"row non-dots\"><div class=\"col-12\"><p class=\"text-justify mx-\">Todos os nosso produtos são de fabricação própria, com mão de obra especializada e humanizada. Buscamos oferecer aos nosso clientes produtos de alta qualidade com os melhores preços. Aceitamos encomendas de roupas sob medida.</p></div></div><div class=\"row non-dots\"><div class=\"col-12\"><p class=\"text-justify mx-\">Conheça um pouco da nossa produção</p></div></div><div id=\"gridProduto\" class=\"row\"><div class=\"col-lg-3 col-md-4 col-sm-6 col-xs-6 col-6 thumb\" data-ng-repeat=\"produto in vm.produtos track by $index\"><div class=\"thumbnail text-center\"><div ng-click=\"vm.openImage($index)\"><img ng-src=\"{{produto.src}}\" class=\"img-responsive img-centered\" title=\"{{image.content}}\" alt=\"{{image.content}}\"></div><app-route route=\"detalhes\" identificador=\"{{produto.identificador}}\"><p class=\"text-center produto-grid\" ng-bind=\"produto.name\" title=\"{{produto.name}}\"></p></app-route></div></div></div></section>");
$templateCache.put("app/roupas/visualizacao.modal.html","<div class=\"galleryModule1\" data-keyboard=\"true\"><button class=\"button-cancel\" ng-click=\"vm.cancelar()\" type=\"button\" aria-label=\"Close\"><span class=\"fa fa-remove\"></span></button><div class=\"modal-body\"><div class=\"carousel\" ng-swipe-right=\"vm.next()\" ng-swipe-left=\"vm.previous()\" ng-keydown=\"vm.keypress($event)\"><div class=\"carousel-inner\"><div class=\"item text-center ng-scope active\"><a class=\"ng-scope\"><img fade-in=\"\" class=\"img-centered img-fluid animate-show\" ng-src=\"{{vm.image.src}}\" alt=\"\"></a> <a role=\"button\" href=\"\" style=\"margin-top: 50vh;\" class=\"float-left carousel-control\" ng-click=\"vm.previous()\"><span aria-hidden=\"true\" class=\"fa fa-2x fa-chevron-left\"></span> <span class=\"sr-only\">previous</span></a> <a role=\"button\" href=\"\" style=\"margin-top: 50vh;\" class=\"float-right carousel-control\" ng-click=\"vm.next()\"><span aria-hidden=\"true\" class=\"fa fa-2x fa-chevron-right\"></span> <span class=\"sr-only\">next</span></a></div></div></div></div><div class=\"clearfix\"></div></div>");
$templateCache.put("app/sobre/sobre.html","<div id=\"sobre\"><h3>Magos da cerveja</h3><div class=\"row\"><div class=\"col-md-6\"><carousel-gallery images=\"vm.photoList\" thumbnails=\"false\"></carousel-gallery></div><div class=\"col-md-6\"><p>Descubra a magia de fazer a sua cerveja!<br><br>Nossa loja possui todos os insumos que você vai utilizar na sua fabricação.<br><br>Possuímos toda linha de Maltes, Lúpulos e Leveduras. Prestamos assessoria.</p></div></div></div>");
$templateCache.put("app/components/carouselGallery/carouselGallery.html","<uib-carousel active=\"vm.active\" interval=\"7000\"><uib-slide ng-repeat=\"photo in vm.images track by $index\" index=\"$index\"><img class=\"img-responsive img-centered\" ng-src=\"{{photo.src}}\" ng-class=\"vm.styleClass\"><div class=\"carousel-caption\"><p>{{photo.content}}</p></div></uib-slide></uib-carousel><div class=\"clearfix\"><div class=\"row\" ng-if=\"vm.thumbnails\"><div class=\"col-lg-2 col-md-2 col-sm-3 col-xs-3\" ng-repeat=\"photo in vm.images track by $index\"><div class=\"thumbnail\" ng-click=\"vm.setActive($index)\"><img class=\"img-responsive img-centered\" ng-src=\"{{photo.src}}\"></div></div></div></div>");
$templateCache.put("app/components/contato/contato.html","<form name=\"form\" novalidate=\"\"><div class=\"form-group\"><div class=\"row\" ng-if=\"!vmContato.formularioHabilitado()\"><div class=\"col-md-12\"><div class=\"alert alert-success\">Seu contato foi enviado com sucesso.</div></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">Nome</label> <input class=\"form-control\" type=\"text\" ng-required=\"true\" ng-model=\"vmContato.contato.name\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">E-mail</label> <input class=\"form-control\" type=\"email\" ng-required=\"true\" ng-model=\"vmContato.contato.email\"></div></div><div class=\"row\"><div class=\"col-md-12\"><label class=\"control-label\">Mensagem</label> <textarea ng-required=\"true\" class=\"form-control\" rows=\"5\" ng-model=\"vmContato.contato.mensagem\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-default btn-success\" ng-click=\"vmContato.send()\">Enviar</button></div></div></div></form>");
$templateCache.put("app/components/footer/footer.html","<section id=\"maps\"><ng-map default-style=\"true\" center=\"{{footerController.locations}}\" zoom=\"15\"><marker id=\"foo\" position=\"{{footerController.locations}}\" on-click=\"footerController.map.showInfoWindow(\'bar\')\"></marker><shape name=\"circle\" radius=\"40\" center=\"{{footerController.locations}}\"><control name=\"overviewMap\" opened=\"true\"><info-window id=\"bar\"><div ng-non-bindable=\"\"><h5 id=\"firstHeading\" class=\"firstHeading\">{{footerController.empresa}}</h5><div id=\"bodyContent\"><p>{{footerController.empresaDescricao}}</p></div></div></info-window></control></shape></ng-map></section><div class=\"titulo\"></div><div class=\"footer\"><div class=\"footer-abovea\"><div class=\"container\"><div class=\"row\"><div class=\"center footer-col col-6\"><ul class=\"links\"><li><a target=\"_blank\" href=\"https://loja.ateliezeffa.com.br/\">Loja</a></li><li><a target=\"_blank\" href=\"https://api.whatsapp.com/send?phone=5548996364820&text=Ol%C3%A1%20\">Whatsapp</a></li></ul></div><div class=\"center footer-col col-6\"><div class=\"footer-blocks-block\"><div class=\"footer-blocks-subblock\"><div class=\"social-media-link-list\"><span class=\"title-with-level social-media-link-list-title century-std size-s uppercase\"><span class=\"multiline-text\">SIGA-NOS</span></span><ul class=\"icons\"><li><a href=\"https://www.facebook.com/ateliezeffa\" class=\"social-media-link\" target=\"_blank\" rel=\"\"><span class=\"visually-hidden\">Facebook</span> <span aria-hidden=\"true\" class=\"icon\" style=\"color:black;fill:black\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1 1)\"><circle cx=\"25\" cy=\"25\" r=\"25\" fill=\"#FFF\" stroke=\"#000\"></circle><path stroke=\"#010002\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M25.778 34v-7.819h2.624l.394-3.048h-3.018v-1.946c0-.882.244-1.483 1.511-1.483l1.612-.001v-2.727c-.279-.036-1.236-.119-2.35-.119-2.327 0-3.92 1.42-3.92 4.028v2.248H20v3.048h2.631V34h3.147z\"></path></g></g></svg></span></a></li><li><a href=\"https://www.instagram.com/ateliezeffa#\" class=\"social-media-link\" target=\"_blank\" rel=\"\"><span class=\"visually-hidden\">Instagram</span> <span aria-hidden=\"true\" class=\"icon\" style=\"color:black;fill:black\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 52 52\"><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1 1)\"><circle cx=\"25\" cy=\"25\" r=\"25\" fill=\"#FFF\" stroke=\"#000\"></circle><path fill=\"#000\" d=\"M29.865 19.162a.973.973 0 1 1-.001 1.947.973.973 0 0 1 0-1.947z\"></path><path stroke=\"#000\" d=\"M25 20.622a4.378 4.378 0 1 1 0 8.756 4.379 4.379 0 0 1 0-8.756z\"></path><path stroke=\"#000\" d=\"M21.108 16.243h7.784a4.865 4.865 0 0 1 4.865 4.865v7.784a4.865 4.865 0 0 1-4.865 4.865h-7.784a4.865 4.865 0 0 1-4.865-4.865v-7.784a4.865 4.865 0 0 1 4.865-4.865z\"></path></g></g></svg></span></a></li></ul></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/gridGallery/gridGallery.html","<div class=\"col-lg-3 col-md-4 col-xs-6 thumb\"><span class=\"thumbnail\"><a class=\"image-wrapper\"><img gallery-image=\"\" ng-src=\"{{ image.src }}\" class=\"img-responsive\" title=\"{{image.content}}\" alt=\"{{image.content}}\" style=\"max-height: 165px\"></a><p class=\"title\" ng-bind=\"image.content\" title=\"{{image.content}}\"></p></span></div>");
$templateCache.put("app/components/jcarousel/jcarousel-item.html","<li ng-transclude=\"\" class=\"thumbnail\"></li>");
$templateCache.put("app/components/jcarousel/jcarousel.html","<div class=\"jcarousel-wrapper2\"><div data-jcarousel=\"true\" data-wrap=\"circular\" class=\"jcarousel\" ng-swipe-right=\"vm.prev()\" ng-swipe-left=\"vm.next()\"><ul ng-transclude=\"\" class=\"thumb\"></ul><a data-jcarousel-control=\"true\" data-target=\"-=1\" href=\"#\" class=\"left carousel-control\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span></a> <a data-jcarousel-control=\"true\" data-target=\"+=1\" href=\"#\" class=\"right carousel-control\"><span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span></a></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-expand-lg navbar-fixed-top navbar-light navbar-custom titulo\"><div class=\"container\"><div class=\"navbar-brand\" id=\"titulo\"><app-route route=\"home\"><img class=\"img-fluid img-header\" src=\"assets/images/Logo.png\" alt=\"Ateliê Zeffa\"></app-route></div><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#myNave\" aria-controls=\"myNave\" aria-expanded=\"false\" aria-label=\"Toggle navigation\"><span class=\"navbar-toggler-icon\"></span></button><div class=\"collapse navbar-collapse\" id=\"myNave\"><ul class=\"navbar-nav mr-auto\"><li class=\"nav-item\"><app-route class=\"nav-link\" route=\"home\">Home</app-route></li><li class=\"nav-item\"><app-route class=\"nav-link\" route=\"roupas\">Roupas</app-route></li><li class=\"nav-item\"><app-route class=\"nav-link\" route=\"home\" scroll-to=\"personalizacao\">Personalização</app-route></li><li class=\"nav-item\"><app-route class=\"nav-link\" route=\"home\" scroll-to=\"contato\">Contato</app-route></li></ul></div></div></nav>");
$templateCache.put("app/components/router-link/router-link.html","<a ng-href=\"{{vm.createLink()}}\" ng-transclude=\"\"></a>");
$templateCache.put("app/components/title/title.html","<h3>{{titulo}}</h3>");}]);